import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubSectionImages = async (pub_id) => {
    const { data } = await API.get(`/api/v1/rbzo/pubs/table/${pub_id}/section/images`);
    return data;
};
export const usePubSectionImages = (pub_id) => {
    return useQuery(["pub_section_images", pub_id], () => getPubSectionImages(pub_id), {
        enabled: !!pub_id,
        cacheTime: 1000 * 60 * 10,
        staleTime: 1000 * 60 * 30,
        retry: 2,
        refetchOnWindowFocus: false,
    });
};
